import { Moment } from 'moment';
import { Logger } from '../../../../../utils/Logger';
import { Component, OnInit } from '@angular/core';
import { isEmpty, orderBy } from 'lodash';
import { MatTableDataSource } from '@angular/material/table';
import { FinalCertificate } from './flex-final-certificate';

import { Keys, StorageService } from '../../../../../service/storage.service';
import { FlexFinalCertificateViewModel } from './flex-final-certificate-view-model';
import { InterestCertificateService } from '../../../../../service/interest-certificate.service';
import * as moment from 'moment';
import { AccountService } from '../../../../../service/finzy-flex/account/account.service';

@Component({
  selector: 'app-flex-interest-certificate',
  templateUrl: './flex-interest-certificate.component.html',
  styleUrls: ['./flex-interest-certificate.component.css'],
  providers: [InterestCertificateService]
})
export class FlexInterestCertificateComponent implements OnInit {

private static readonly AprilMonth = 3;
    public shouldShowFinalCertificatesTable = false;
    public shouldShowFinalCertificatesLoader = false;
    public readonly financialYears;
    public readonly finalInterestCertificateColumnsToBeDisplayed = ['financialYear', 'downloadUrl', 'downloadStatementOfReturn'];
    public flexFinalInterestCertificateDataSource: MatTableDataSource<FlexFinalCertificateViewModel>;

    private readonly storageService: StorageService;
    private readonly interestCertificateService: InterestCertificateService;
    private readonly accountService: AccountService;

    public isFINXLender: boolean = false;

    constructor(
        storageService: StorageService, 
        interestCertificateService: InterestCertificateService,
        accountService: AccountService) {
        this.storageService = storageService;
        this.interestCertificateService = interestCertificateService;
        this.accountService = accountService;
        this.financialYears = this.generateFinancialYears().map(val => val.displayValue);
        this.isFINXLender = this.storageService.getItem(Keys.FINX) === "true" && this.storageService.getItem(Keys.IS_LENDER_CREATED_AFTER_RESTRICTED_DATE) === "true";
    }

    public downloadInterestCertificateFile(financialYear: string): void {
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const generatedUserId = this.storageService.getItem(Keys.GENERATED_USER_ID);
        this.accountService.downloadInterestCertificate(financialYear, lenderId)
            .then((res) => {
            const interestCertificateFile = res;
            let downloadUrl = URL.createObjectURL(interestCertificateFile);
            let downloadElem = document.createElement('a');
            downloadElem.href = downloadUrl;
            downloadElem.download = `Interest_Certificate_${generatedUserId}_${financialYear}.zip`;
            downloadElem.click();
            })
            .catch((err) => {
                console.log(err)
            })
    }

    public downloadStatementOfReturnsFile(financialYear: string): void {
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const generatedUserId = this.storageService.getItem(Keys.GENERATED_USER_ID);
        this.accountService.downloadStatementOfReturns(financialYear, lenderId)
            .then((res) => {
            const interestCertificateFile = res;
            let downloadUrl = URL.createObjectURL(interestCertificateFile);
            let downloadElem = document.createElement('a');
            downloadElem.href = downloadUrl;
            downloadElem.download = `Statement_of_returns_${generatedUserId}_${financialYear}.zip`;
            downloadElem.click();
            })
            .catch((err) => {
                console.log(err)
            })
    }

    async ngOnInit(): Promise<void> {
        this.showSetupLoaders();
        const finalCertificates = await this.interestCertificateService.getFlexFinalCertificates();
        const finalCertificatePerYear = this.getDistinctFinalCertificatePerYear(finalCertificates);
        await this.getAndShowFinalInterestCertificateData(finalCertificatePerYear);
        this.hideSetupLoaders();
    }

    public showSetupLoaders() {
        this.shouldShowFinalCertificatesLoader = true;
    }

    public hideSetupLoaders() {
        this.shouldShowFinalCertificatesLoader = false;
    }

    private async getAndShowFinalInterestCertificateData(finalCertificates: FinalCertificate[]) {
        const token = this.storageService.getItem(Keys.TOKEN);
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        const flexFinalCertificateViewModels = finalCertificates.map((certificate: FinalCertificate) => {
            const flexFinalCertificateViewModel = FlexFinalCertificateViewModel.from(certificate, profileId, token);
            Logger.log(`Generated final certificate url: [${flexFinalCertificateViewModel.downloadUrl}]`);
            return flexFinalCertificateViewModel;
        });

        this.flexFinalInterestCertificateDataSource = new MatTableDataSource<FlexFinalCertificateViewModel>(flexFinalCertificateViewModels);
        this.shouldShowFinalCertificatesTable = !isEmpty(flexFinalCertificateViewModels);
    }

    private generateFinancialYears(): ({ displayValue: string; start: Moment; end: Moment })[] {
        let currentStartOfFinancialYear: number;
        const currentMonth = moment().month();
        if (currentMonth < FlexInterestCertificateComponent.AprilMonth) {
            currentStartOfFinancialYear = moment().year() - 1;
        } else {
            currentStartOfFinancialYear = moment().year();
        }

        const previousFinancialYear = `${currentStartOfFinancialYear - 1}-${currentStartOfFinancialYear}`;
        const currentFinancialYear = `${currentStartOfFinancialYear}-${currentStartOfFinancialYear + 1}`;
        return [{
            start: moment().year(currentStartOfFinancialYear - 1).month('April').startOf('month'),
            end: moment().year(currentStartOfFinancialYear).month('March').endOf('month'),
            displayValue: previousFinancialYear
        }, {
            start: moment().year(currentStartOfFinancialYear).month('April').startOf('month'),
            end: moment().year(currentStartOfFinancialYear + 1).month('March').endOf('month'),
            displayValue: currentFinancialYear
        }];
    }

    private getDistinctFinalCertificatePerYear(finalCertificates: FinalCertificate[]) {
        const distinctFinancialYears = Array.from(new Set(finalCertificates.map(certificate => certificate.financialYear)));
        const shortlistedCertificates = [];

        distinctFinancialYears.forEach((key: string) => {
            const certificatesForFinancialYear = finalCertificates.filter((certificate) => certificate.financialYear === key);
            shortlistedCertificates.push(orderBy(certificatesForFinancialYear, cert => cert.createdAt, 'desc')[0]);
        });
        return shortlistedCertificates;
    }
}